import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import { CircularProgress } from '@mui/material';
import { Background, Container, Text } from './styled';
export const RoomLoader = () => createPortal(_jsx(Background, { children: _jsxs(Container, { children: [_jsx(Text, { children: "This might take few seconds" }), _jsx(CircularProgress, {})] }) }), document.body);
